// react-i18next 설정 파일
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 번역 파일 import
import commonKo from './locales/ko/common.json';
import errorsKo from './locales/ko/errors.json';
import adminKo from './locales/ko/admin.json';

import commonEn from './locales/en/common.json';
import errorsEn from './locales/en/errors.json';
import adminEn from './locales/en/admin.json';

import commonZh from './locales/zh/common.json';
import errorsZh from './locales/zh/errors.json';
import adminZh from './locales/zh/admin.json';

import commonJa from './locales/ja/common.json';
import errorsJa from './locales/ja/errors.json';
import adminJa from './locales/ja/admin.json';

import commonPt from './locales/pt/common.json';
import errorsPt from './locales/pt/errors.json';
import adminPt from './locales/pt/admin.json';

import commonAr from './locales/ar/common.json';
import errorsAr from './locales/ar/errors.json';
import adminAr from './locales/ar/admin.json';

// 번역 리소스
const resources = {
  ko: {
    common: commonKo,
    errors: errorsKo,
    admin: adminKo,
  },
  en: {
    common: commonEn,
    errors: errorsEn,
    admin: adminEn,
  },
  zh: {
    common: commonZh,
    errors: errorsZh,
    admin: adminZh,
  },
  ja: {
    common: commonJa,
    errors: errorsJa,
    admin: adminJa,
  },
  pt: {
    common: commonPt,
    errors: errorsPt,
    admin: adminPt,
  },
  ar: {
    common: commonAr,
    errors: errorsAr,
    admin: adminAr,
  },
};

i18n
  // 브라우저 언어 자동 감지
  .use(LanguageDetector)
  // React와 연동
  .use(initReactI18next)
  // 초기화
  .init({
    resources,
    fallbackLng: 'ko', // 기본 언어 (한국어)
    supportedLngs: ['ko', 'en', 'zh', 'ja', 'pt', 'ar'], // 지원 언어
    ns: ['common', 'errors', 'admin'], // 네임스페이스
    defaultNS: 'common', // 기본 네임스페이스
    interpolation: {
      escapeValue: false, // React는 XSS 방어 자동 처리
    },
    detection: {
      // 언어 감지: 항상 시스템 언어(navigator) 사용
      order: ['navigator', 'htmlTag'],
      // 캐시 비활성화 - 매번 시스템 언어로 리셋
      caches: [],
    },
  });

export default i18n;
